(function(){
 'use strict';
 function modelKey(sku){
  const match=String(sku||'').trim().toUpperCase().match(/^(?:NT-)?TXW-([A-Z0-9]+)-[A-Z0-9]/);
  return match && /^(?:HC|YC|KC|SC|BC|DC)/.test(match[1]) ? match[1] : '';
 }
 function uniqueParts(items,currentVariant){
  const bySku=new Map();
  items.forEach(item=>{const sku=item.dataset.sku.trim().toUpperCase();if(!bySku.has(sku))bySku.set(sku,new Map());bySku.get(sku).set(item.dataset.variant,item);});
  return [...bySku.values()].flatMap(m=>m.size===1?[...m.values()]:m.has(currentVariant)?[m.get(currentVariant)]:[]);
 }
 function coversYears(raw,required){
  try{const value=JSON.parse(raw),available=new Set((Array.isArray(value)?value:[value]).map(Number));const years=String(required||'').split(',').map(Number).filter(y=>y>=1980&&y<=2100);return years.length>0&&years.every(y=>available.has(y));}catch{return false;}
 }
 if(typeof module!=='undefined'&&module.exports){module.exports={modelKey,uniqueParts,coversYears};return;}
 if(window.NTCarbonParts)return;window.NTCarbonParts={modelKey};
 function mountChooser(root,block){
  const native=root.querySelector('label.nt-pdp__variant');
  if(native){native.hidden=true;native.dataset.ntCarbonReplaced='true';native.before(block);return;}
  const delivery=root.querySelector('.nt-shared-delivery');
  if(delivery){delivery.before(block);return;}
  const form=root.querySelector('form.nt-pdp__form');
  if(form){form.before(block);return;}
  root.querySelector('.nt-pdp__details')?.append(block);
 }
 function enhance(root,block,config){
  if(!window.NTProductLayout||!root.dataset.sectionId)return;
  var cache=new Map(),serial=0,prefetchTimer,observer,contentWork=Promise.resolve();
  function family(c){return modelKey(c.dataset.sku);}
  var list=block.querySelector('.nt-carbon-parts__list'),selected=block.querySelector('.nt-carbon-parts__selected');
  var links=Array.from(list.querySelectorAll('a'));
  var paths=new Set(links.map(function(a){return key(a.href);}));
  selected.setAttribute('aria-live','polite');
  function watch(){
   if(observer)observer.disconnect();
   var details=root.querySelector('.nt-pdp__details');
   observer=new MutationObserver(function(){if(!root.contains(block)){var parent=root.querySelector('.nt-pc-info-scroll')||details;if(parent)parent.append(block);}});
   if(details)observer.observe(details,{childList:true,subtree:true});
  }
  document.addEventListener('click',function(event){if(root.dataset.ntCarbonLoading==='true'&&event.target.closest('button')&&!block.contains(event.target)){event.preventDefault();event.stopImmediatePropagation();}},true);
  watch();
  function key(url){var u=new URL(url,location.origin);return u.pathname+'?variant='+u.searchParams.get('variant');}
  function read(url){
   var id=key(url),entry=cache.get(id);
   if(entry&&Date.now()-entry.time<20000)return entry.promise;
   var u=new URL(url,location.origin);u.searchParams.set('section_id',root.dataset.sectionId);
   var controller=new AbortController(),timer=setTimeout(function(){controller.abort();},12000);
   var promise=fetch(u.href,{credentials:'same-origin',signal:controller.signal}).then(function(response){
    if(!response.ok)throw new Error('Product unavailable');return response.text();
   }).then(function(html){
    var doc=new DOMParser().parseFromString(html,'text/html'),product=doc.querySelector('[data-nt-product]'),c=doc.querySelector('[data-nt-carbon-config]');
    if(!product||!c||product.dataset.fulfillment!=='us'||product.dataset.currentAvailable!=='true')throw new Error('Product not eligible');
    if(c.dataset.variant!==new URL(url,location.origin).searchParams.get('variant'))throw new Error('Unexpected variant');
    if(!family(c)||family(c)!==family(config))throw new Error('Different fitment');
    if(new URL(product.dataset.productUrl,location.origin).pathname!==new URL(url,location.origin).pathname)throw new Error('Unexpected product');
    return product;
   }).catch(function(error){cache.delete(id);throw error;}).finally(function(){clearTimeout(timer);});
   cache.delete(id);cache.set(id,{time:Date.now(),promise:promise});
   while(cache.size>6)cache.delete(cache.keys().next().value);
   return promise;
  }
  function warm(link){
   if(!link||link.classList.contains('is-current')||(navigator.connection&&navigator.connection.saveData))return;
   read(link.href).then(function(product){var image=product.querySelector('[data-nt-main-image]');if(image){var img=new Image();img.src=image.src;}}).catch(function(){});
  }
  function intent(event){
   var link=event.target.closest('a');if(!link||!list.contains(link))return;
   clearTimeout(prefetchTimer);prefetchTimer=setTimeout(function(){warm(link);},90);
  }
  list.addEventListener('pointerover',intent);list.addEventListener('focusin',intent);
  list.addEventListener('pointerleave',function(){clearTimeout(prefetchTimer);});
  function readyImage(product){
   var source=product.querySelector('[data-nt-main-image]');if(!source)return Promise.reject(new Error('Missing product image'));
   return new Promise(function(resolve,reject){
    var img=new Image(),timer=setTimeout(function(){reject(new Error('Image timed out'));},5000);
    img.onload=function(){clearTimeout(timer);resolve();};img.onerror=function(){clearTimeout(timer);reject(new Error('Image unavailable'));};img.src=source.src;
    if(img.complete&&img.naturalWidth){clearTimeout(timer);resolve();}
   });
  }
  function busy(link){
   root.dataset.ntCarbonLoading='true';root.querySelectorAll('button[type=submit],button[data-nt-add-to-cart],button[data-nt-buy-now]').forEach(function(b){b.dataset.carbonWasDisabled=String(b.disabled);b.disabled=true;});root.setAttribute('aria-busy','true');
   links.forEach(function(a){a.classList.toggle('is-loading',a===link);});
  }
  function idle(){
   delete root.dataset.ntCarbonLoading;root.querySelectorAll('[data-carbon-was-disabled]').forEach(function(b){b.disabled=b.dataset.carbonWasDisabled==='true';delete b.dataset.carbonWasDisabled;});root.removeAttribute('aria-busy');links.forEach(function(a){a.classList.remove('is-loading');});
  }
  function select(path){
   links.forEach(function(a){var current=key(a.href)===path;a.classList.toggle('is-current',current);if(current){a.setAttribute('aria-current','page');selected.textContent=a.dataset.partLabel;block.querySelector('select[data-nt-carbon-select]').value=a.dataset.variant;}else a.removeAttribute('aria-current');});
  }
  function mountBlock(){
   var target=root.querySelector('.nt-pc-info-scroll')||root.querySelector('.nt-pdp__details'),form=target&&target.querySelector('form');
   if(!target)throw new Error('Missing product details');
   mountChooser(root,block);
  }
  function metadata(){
   document.title=root.dataset.productTitle+' – NT FAIRING';
   var canonical=document.querySelector('link[rel="canonical"]');if(canonical)canonical.href=root.dataset.productUrl;
   var values={'og:title':root.dataset.productTitle,'og:url':root.dataset.productUrl,'og:image':root.dataset.productImage};
   Object.keys(values).forEach(function(name){var node=document.querySelector('meta[property="'+name+'"]');if(node)node.content=values[name];});
  }
  function contentLayout(){
   var original=root.querySelector('script[src*="/nt-pdp-content-layout.js"]');
   if(!original)return;
   var url=new URL(original.src,location.origin);
   if(url.origin!==location.origin||!url.pathname.includes('/assets/'))return;
   var target=root;contentWork=contentWork.then(function(){
    if(root!==target||root.querySelector('.nt-description-story'))return;
    return new Promise(function(resolve){var script=document.createElement('script');script.src=url.href;script.onload=script.onerror=function(){script.remove();resolve();};root.append(script);});
   });
  }
  async function navigate(url,options){
   options=options||{};
   var run=++serial,u=new URL(url,location.origin),link=links.find(function(a){return key(a.href)===key(u.href);});
   if(!link)return location.assign(u.href);
   if(u.pathname===new URL(root.dataset.productUrl).pathname && u.searchParams.get('variant')===root.querySelector('[data-nt-carbon-config]').dataset.variant){idle();return;}
   busy(link);
   try{
    var product=await read(u.href);await readyImage(product);if(run!==serial)return;
    var next=document.importNode(product,true),previous=root;
    var anchor=block.getBoundingClientRect().top,x=list.scrollLeft,scrollX=window.scrollX,scrollY=window.scrollY;
    var panel=previous.querySelector('.nt-pc-info-scroll'),panelScroll=panel?panel.scrollTop:0;
    var quantity=previous.querySelector('input[name="quantity"]'),quantityValue=quantity&&quantity.value;
    var focused=document.activeElement&&block.contains(document.activeElement)?document.activeElement:null;
    observer.disconnect();block.remove();previous.dispatchEvent(new Event('nt:product:unload'));
    previous.replaceWith(next);root=next;
    root.style.visibility='visible';window.NTProductLayout(root);
    root.dispatchEvent(new CustomEvent('nt:product:mount',{bubbles:true}));
    mountBlock();select(key(u.href));list.scrollLeft=x;
    if(quantityValue)root.querySelectorAll('input[name="quantity"]').forEach(function(input){input.value=quantityValue;input.dispatchEvent(new Event('change',{bubbles:true}));});
    panel=root.querySelector('.nt-pc-info-scroll');if(panel)panel.scrollTop=panelScroll;
    if(!options.pop)history.pushState(Object.assign({},history.state,{ntCarbonProduct:true}),'',u.pathname+u.search+u.hash);
    metadata();contentLayout();idle();watch();
    requestAnimationFrame(function(){if(run!==serial)return;window.scrollTo({left:scrollX,top:Math.max(0,window.scrollY+block.getBoundingClientRect().top-anchor),behavior:'instant'});list.scrollLeft=x;if(focused)focused.focus({preventScroll:true});});
   }catch(error){if(run===serial){idle();if(options.pop)location.replace(u.href);else location.assign(u.href);}}
  }
  block.navigateToPart=navigate;
  var initialUrl=new URL(location.href);initialUrl.searchParams.set('variant',config.dataset.variant);history.replaceState(Object.assign({},history.state,{ntCarbonProduct:true}),'',initialUrl.pathname+initialUrl.search);
  list.addEventListener('click',function(event){
   var link=event.target.closest('a');
   if(!link||!list.contains(link)||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.target==='_blank')return;
   event.preventDefault();clearTimeout(prefetchTimer);navigate(link.href);
  });
  window.addEventListener('popstate',function(event){
   if(event.state&&event.state.ntCarbonProduct&&paths.has(key(location.href)))navigate(location.href,{pop:true});
   else if(event.state&&event.state.ntCarbonProduct)location.reload();
  });
 }

 async function init(){
  const root=document.querySelector('[data-nt-product]'),config=root?.querySelector('[data-nt-carbon-config]');
  if(!config)return;
  const nativeSelect=root.querySelector('[data-nt-variant-select]');
  if(nativeSelect){
   const outOfStock=new Set((config.dataset.outOfStock||'').split(','));
   const isUnavailable=option=>option&&(option.dataset.available==='false'||outOfStock.has(option.value));
   const unavailable=isUnavailable(nativeSelect.selectedOptions[0]);
   [...nativeSelect.options].filter(isUnavailable).forEach(option=>option.remove());
   if(unavailable){const prompt=document.createElement('option');prompt.value='';prompt.textContent=config.dataset.heading;prompt.disabled=true;prompt.selected=true;nativeSelect.prepend(prompt);}
  }
  const family=modelKey(config.dataset.sku);if(!family)return;
  const preview=new URL(location.href).searchParams.get('preview_theme_id');
  const base=window.Shopify?.routes?.root||'/';
  let next=new URL(base+'collections/carbon-fiber-parts',location.origin);
  const found=[],seen=new Set();
  try{
   while(next){
    next.searchParams.set('section_id','nt-carbon-parts-feed');
    if(preview)next.searchParams.set('preview_theme_id',preview);
    if(seen.has(next.href)||seen.size>=20)throw Error('Invalid feed pagination');seen.add(next.href);
    const response=await fetch(next.href,{credentials:'same-origin',signal:AbortSignal.timeout(15000)});
    if(!response.ok)throw Error('Feed unavailable');
    const doc=new DOMParser().parseFromString(await response.text(),'text/html'),feed=doc.querySelector('[data-nt-carbon-feed]');
    if(!feed)throw Error('Missing feed');
    feed.querySelectorAll('[data-nt-carbon-item]').forEach(item=>{if(modelKey(item.dataset.sku)===family&&(item.dataset.variant===config.dataset.variant||coversYears(item.dataset.years,root.dataset.modelYears)))found.push(item);});
    next=feed.dataset.next?new URL(feed.dataset.next,location.origin):null;
    if(next&&next.origin!==location.origin)throw Error('Invalid feed origin');
   }
   const items=uniqueParts(found,config.dataset.variant);
   if(!items.length)return;
   const current=items.find(x=>x.dataset.variant===config.dataset.variant);
   if(items.length===1&&current)return;
   const block=document.createElement('section');block.className='nt-carbon-parts';block.setAttribute('aria-label',config.dataset.heading);
   const heading=document.createElement('label');heading.textContent=config.dataset.heading;heading.htmlFor='nt-carbon-parts-select';
   const dropdown=document.createElement('select');dropdown.id=heading.htmlFor;dropdown.dataset.ntCarbonSelect='';
   if(!current){const prompt=document.createElement('option');prompt.value='';prompt.textContent=config.dataset.heading;prompt.disabled=true;prompt.selected=true;dropdown.append(prompt);}
   const selected=document.createElement('span');selected.className='nt-carbon-parts__selected';selected.hidden=true;
   const list=document.createElement('div');list.className='nt-carbon-parts__list';list.hidden=true;
   function label(item){
    const part=item.dataset.part;
    if(part&&!/^default title$/i.test(part))return part.replace(/\s*—\s*Unavailable$/i,'');
    return item.dataset.title.replace(/^NT\s+/i,'').replace(/(?:100%|real|3k|twill)\s*/ig,'').replace(/carbon fiber\s*/ig,'').replace(/\s+(?:fit\s+)?for\s+.+$/i,'').trim()||item.dataset.title;
   }
   items.sort((a,b)=>label(a).localeCompare(label(b))).forEach(item=>{
    const a=document.createElement('a'),url=new URL(item.getAttribute('href'),location.origin);
    if(preview)url.searchParams.set('preview_theme_id',preview);
    a.href=url.pathname+url.search;a.dataset.variant=item.dataset.variant;a.dataset.partLabel=label(item);a.title=label(item)+' · '+item.dataset.sku;a.setAttribute('aria-label',label(item));
    const name=document.createElement('span');name.className='nt-carbon-parts__name';name.textContent=label(item);
    a.append(name);
    if(item.dataset.variant===config.dataset.variant){a.classList.add('is-current');a.setAttribute('aria-current','page');selected.textContent=label(item);}
    list.append(a);
    const option=document.createElement('option');option.value=item.dataset.variant;option.textContent=label(item)+(item.dataset.available==='false'?' — '+config.dataset.unavailable:'');option.disabled=item.dataset.available==='false';option.selected=item.dataset.variant===config.dataset.variant;dropdown.append(option);
   });
   block.append(heading,dropdown,selected,list);
   dropdown.addEventListener('change',()=>{const link=[...list.querySelectorAll('a')].find(a=>a.dataset.variant===dropdown.value);if(link){if(block.navigateToPart)block.navigateToPart(link.href);else location.assign(link.href);}});
   mountChooser(root,block);
   const preserve=new MutationObserver(()=>{if(!root.isConnected){preserve.disconnect();return;}if(!root.contains(block)){root.querySelectorAll('.nt-carbon-parts').forEach(copy=>copy.remove());mountChooser(root,block);}});
   preserve.observe(root,{childList:true,subtree:true});
   enhance(root,block,config);
  }catch(error){console.warn(config.dataset.error,error.message);}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
